import { Injectable } from '@angular/core';
import { StoreBase } from '@stores/abstract';
import { StoreLocator } from '@stores/models';

@Injectable({ providedIn: 'root' })
export class StoreLocatorStore extends StoreBase<StoreLocator> {
  override storeName = 'StoreLocatorStore';
}
